export enum NodeTypes {
  NATURAL_PERSON = 'NP',
  LEGAL_ENTITY = 'LE',
  NATURAL_PERSON_GROUP = 'NPG',
  PRODUCT = 'PD'
}
